import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex p-2 m-2 flex-shrink-0 surface-a"
}
const _hoisted_2 = { class: "d-flex flex-column ml-1 w-75" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = {
  key: 1,
  class: "w-100"
}
const _hoisted_5 = { class: "p-2 m-2 surface-a" }
const _hoisted_6 = { class: "d-flex flex-column mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (!_ctx.isGridLayout)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Skeleton, {
          height: "222px",
          width: "400px"
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Skeleton, {
              class: "mb-1",
              height: "1.4rem",
              width: "20%"
            }),
            _createVNode(_component_Skeleton, {
              class: "mb-1",
              height: ".75rem",
              width: "100%"
            }),
            _createVNode(_component_Skeleton, {
              class: "mb-1",
              height: ".75rem",
              width: "90%"
            }),
            _createVNode(_component_Skeleton, {
              class: "mb-1",
              height: ".75rem",
              width: "95%"
            }),
            _createVNode(_component_Skeleton, {
              height: ".75rem",
              width: "80%"
            })
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Skeleton, {
            height: "225px",
            width: "100%"
          }),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Skeleton, {
              class: "mb-1",
              height: "1.25rem",
              width: "40%"
            })
          ])
        ])
      ]))
}